"use strict";

var cov_tcwdy3j11 = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\parallel-scripture\\Headers.js";
  var hash = "79364d836e7e657a2015e0fc3676672514c3c012";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\parallel-scripture\\Headers.js",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 18
        },
        end: {
          line: 13,
          column: 29
        }
      },
      "1": {
        start: {
          line: 14,
          column: 18
        },
        end: {
          line: 22,
          column: 4
        }
      },
      "2": {
        start: {
          line: 14,
          column: 40
        },
        end: {
          line: 14,
          column: 51
        }
      },
      "3": {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 21,
          column: 16
        }
      },
      "4": {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 30,
          column: 3
        }
      },
      "5": {
        start: {
          line: 33,
          column: 0
        },
        end: {
          line: 35,
          column: 2
        }
      },
      "6": {
        start: {
          line: 37,
          column: 18
        },
        end: {
          line: 48,
          column: 3
        }
      },
      "7": {
        start: {
          line: 37,
          column: 39
        },
        end: {
          line: 48,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "Headers",
        decl: {
          start: {
            line: 10,
            column: 9
          },
          end: {
            line: 10,
            column: 16
          }
        },
        loc: {
          start: {
            line: 12,
            column: 3
          },
          end: {
            line: 31,
            column: 1
          }
        },
        line: 12
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 14,
            column: 33
          },
          end: {
            line: 14,
            column: 34
          }
        },
        loc: {
          start: {
            line: 14,
            column: 40
          },
          end: {
            line: 14,
            column: 51
          }
        },
        line: 14
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 14,
            column: 57
          },
          end: {
            line: 14,
            column: 58
          }
        },
        loc: {
          start: {
            line: 15,
            column: 4
          },
          end: {
            line: 21,
            column: 16
          }
        },
        line: 15
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 37,
            column: 29
          },
          end: {
            line: 37,
            column: 30
          }
        },
        loc: {
          start: {
            line: 37,
            column: 39
          },
          end: {
            line: 48,
            column: 1
          }
        },
        line: 37
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "79364d836e7e657a2015e0fc3676672514c3c012"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

function Headers(_ref) {
  var columns = _ref.columns;
  cov_tcwdy3j11.f[0]++;
  var classes = (cov_tcwdy3j11.s[0]++, useStyles());

  var _titles = (cov_tcwdy3j11.s[1]++, columns.filter(function (col) {
    cov_tcwdy3j11.f[1]++;
    cov_tcwdy3j11.s[2]++;
    return !col.hidden;
  }).map(function (column) {
    cov_tcwdy3j11.f[2]++;
    cov_tcwdy3j11.s[3]++;
    return _react.default.createElement(_core.TableCell, {
      key: column.id,
      align: column.align,
      className: classes.cell
    }, column.label);
  }));

  cov_tcwdy3j11.s[4]++;
  return _react.default.createElement(_core.TableHead, {
    className: classes.root
  }, _react.default.createElement(_core.TableRow, null, _titles));
}

;
cov_tcwdy3j11.s[5]++;
Headers.propTypes = {
  columns: _propTypes.default.array.isRequired
};
var useStyles = (cov_tcwdy3j11.s[6]++, (0, _styles.makeStyles)(function (theme) {
  cov_tcwdy3j11.f[3]++;
  cov_tcwdy3j11.s[7]++;
  return {
    root: {},
    cell: {
      position: 'sticky',
      top: '0px',
      padding: 0,
      paddingLeft: theme.spacing(1),
      backgroundColor: '#fff',
      minWidth: '15rem'
    }
  };
}));
var _default = Headers;
exports.default = _default;